<template>
  <!-- 免费房间显示时间段配置 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="倒计时显示时间段配置"
      width="700px"
      @close="closeConfigDialog"
    >
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px">
          <el-select
            style="width: 140px; margin-bottom: 20px"
            v-model="btn_status"
            placeholder="倒计时开关状态"
          >
            <el-option label="开启" :value="1"></el-option>
            <el-option label="关闭" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 20px" label="倒计时时长(秒)：">
          <el-input style="width: 140px" v-model="countdown_time"></el-input>
        </el-form-item>
      </el-form>

      <p
        class="text-line"
        style="margin-bottom: 10px"
        v-for="(item, index) in remarks"
        :key="index"
        v-loading="dialogLoading"
      >
        开启时间段{{ index + 1 }}：
        <!-- <el-time-picker
          v-model="item.start_time"
          format="HH"
          value-format="HH"
          placeholder="开始时间"
        >
        </el-time-picker> -->
        <el-time-picker
          v-model="item.start_time"
          :picker-options="{
            selectableRange: '00:00:00 - 23:59:59',
          }"
          value-format="HH:mm:ss"
          placeholder="开始时间"
        >
        </el-time-picker>
        ——
        <el-time-picker
          v-model="item.end_time"
          :picker-options="{
            selectableRange: '00:00:00 - 23:59:59',
          }"
          value-format="HH:mm:ss"
          placeholder="结束时间"
        >
        </el-time-picker>
        <!-- <el-time-picker
          v-model="item.end_time"
          format="HH"
          value-format="HH"
          placeholder="结束时间"
        >
        </el-time-picker> -->
        <i
          v-if="remarks.length > 1"
          class="el-icon-remove-outline reduce_btn"
          @click="reduceTextLine(index)"
        ></i>
        <i
          v-if="remarks.length - 1 === index"
          class="el-icon-circle-plus-outline add_btn"
          @click="addTextLine"
        ></i>
      </p>
      <p class="btn-box">
        <el-button style="margin-right: 20px" @click="closeConfigDialog"
          >取消</el-button
        >
        <el-button type="primary" @click="submit" :loading="buttonLoading"
          >确定</el-button
        >
      </p>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  components: {},
  props: {
    value: {
      type: Number,
      default: 1
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogLoading: false,//弹窗加载动画
      buttonLoading: false,//按钮加载动画
      btn_status: 0,//开关状态 0是关闭 1是开启
      countdown_time: 0,//倒计时间
      remarks: [{ start_time: 0, end_time: 0 }],//设置弹窗初始数据
    }
  },
  computed: {
    dialogVisible: {//显示标志
      get() {
        return this.visible
      },
      set() { }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    }
  },
  created() {
  },
  methods: {
    getData() {
      //获取表单数据
      this.loading = true
      getApiData(`battle_five_push_enable`).then(res => {
        if (res) {
          this.btn_status = res.enable
          this.countdown_time = res.countdown_time
          this.remarks = res.times

          //按时间进行从小到大排序
          for (let i = 0; i < this.remarks.length - 1; i++) {
            for (let j = 0; j < this.remarks.length - 1 - i; j++) {
              if (this.remarks[j].start_time > this.remarks[j + 1]
                .start_time) {
                let temp = this.remarks[j];
                this.remarks[j] = this.remarks[j + 1];
                this.remarks[j + 1] = temp;
              }
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    addTextLine() {
      //加行
      let params = { start_time: 0, end_time: 0 }
      this.remarks.push(params)
    },
    reduceTextLine(num) {
      //减行
      this.remarks.splice(num, 1)
    },
    submit() {
      //保存编辑好的表单信息
      this.buttonLoading = true

      //检测最大值不能小于最小值
      for (let i = 0, len = this.remarks.length; i < len; i++) {
        if (this.remarks[i] && (parseFloat(this.remarks[i].start_time) > parseFloat(this.remarks[i].end_time))) {
          this.$message.error(`第${i + 1}行，开始时间不能大于结束时间`)
          this.buttonLoading = false
          return
        }
        if (this.remarks[i] && (!this.remarks[i].start_time) && !this.remarks[i].end_time) {
          this.$message.error(`第${i + 1}行，数据不能为空`)
          this.buttonLoading = false
          return
        }

        if (this.remarks[i] && (this.remarks[i].start_time === this.remarks[i].end_time) && (parseFloat(this.remarks[i].start_time) != 23)) {
          this.$message.error(`第${i + 1}行，数据不能相等`)
          this.buttonLoading = false
          return
        }

        // let arr
        // arr.push(this.remarks[i].start_time)
        // arr.push(this.remarks[i].end_time)
      }

      let params

      if (this.remarks.length === 1) {
        if ((!this.remarks[0].start_time || this.remarks[0].start_time == 0) && (!this.remarks[0].end_time || this.remarks[0].end_time == 0)) {
          params = {
            enable: this.btn_status,
            countdown_time: this.countdown_time,
            times: '',
          };
        } else {
          params = {
            enable: this.btn_status,
            countdown_time: this.countdown_time,
            times: this.remarks
          }
        }
      } else {
        params = {
          enable: this.btn_status,
          countdown_time: this.countdown_time,
          times: this.remarks
        }
      }


      patchApiData('battle_five_push_enable', params)
        .then(res => {
          this.$message.success("保存成功！")
          this.closeConfigDialog()//关闭弹窗
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    closeConfigDialog() {
      //关闭弹窗
      this.$emit('close')
    },
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>